import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, Table, Badge, Spinner, Alert } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import { apiGet, errorText, date, APPLICATION_STATUS_VARIANT } from "./sellerApi";

const isPdf = (url) => /\.pdf($|\?)/i.test(url || "");

export default function SellerAccountPage() {
    const [a, setA] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const res = await apiGet("/store-seller/account");
                setA(res.data?.data);
            } catch (e) {
                setError(errorText(e));
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const doc = (label, url) => (
        <Col md={6} key={label}>
            <div className="border rounded-3 p-2 h-100">
                <div className="small fw-semibold mb-1">{label}</div>
                {!url ? <span className="text-muted small">Not uploaded</span> : isPdf(url)
                    ? <a href={url} target="_blank" rel="noreferrer">Open PDF</a>
                    : <a href={url} target="_blank" rel="noreferrer"><img src={url} alt={label} style={{ width: "100%", maxHeight: 200, objectFit: "contain" }} /></a>}
            </div>
        </Col>
    );

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card mb-4">
                        <div className="mc-breadcrumb">
                            <h3 className="mc-breadcrumb-title">Account &amp; Verification</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to="/dashboard" className="mc-breadcrumb-link">Dashboard</Link></li>
                                <li className="mc-breadcrumb-item">Account</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                {error && <Col xl={12}><Alert variant="danger">{error}</Alert></Col>}
                {loading ? <Col xl={12}><div className="text-center py-5"><Spinner animation="border" /></div></Col> : a && (
                    <>
                        <Col lg={6}>
                            <Card className="border-0 shadow-sm rounded-4 mb-4">
                                <Card.Body>
                                    <h5 className="fw-bold mb-3">Profile</h5>
                                    <Table size="sm" className="mb-0">
                                        <tbody>
                                            <tr><th>Store</th><td>{a.store_name}</td></tr>
                                            <tr><th>Name</th><td>{a.profile?.name}</td></tr>
                                            <tr><th>Father&apos;s name</th><td>{a.profile?.father_name || "-"}</td></tr>
                                            <tr><th>Email</th><td>{a.profile?.email} {a.profile?.email_verified && <Badge bg="success">Verified</Badge>}</td></tr>
                                            <tr><th>Phone</th><td>{a.profile?.phone}</td></tr>
                                            <tr><th>Country</th><td>{a.country}</td></tr>
                                            <tr><th>Account</th><td><Badge bg={APPLICATION_STATUS_VARIANT[a.account_status] || "secondary"}>{a.account_status}</Badge> since {date(a.approved_at)}</td></tr>
                                        </tbody>
                                    </Table>
                                    <p className="small text-muted mt-2 mb-0">To change your name, phone or address, update your account on the Watches Pool website.</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg={6}>
                            <Card className="border-0 shadow-sm rounded-4 mb-4">
                                <Card.Body>
                                    <h5 className="fw-bold mb-3">Storage and fees</h5>
                                    <p className="mb-1"><strong>{a.storage_label}</strong></p>
                                    <p className="mb-1">{a.storage_preference === "admin_store" ? "Commission" : "Platform fee"}: <strong>{a.payment_value}%</strong> of the order price</p>
                                    {a.product_limit > 0 && <p className="mb-1">Listing limit: {a.product_limit} ({a.remaining_product_slots} left)</p>}
                                    <p className="small text-muted mb-0">
                                        Payments are held {a.hold_days} days after each sale ({a.complaint_window_days}-day complaint window), then paid to your
                                        default <Link to="/seller-payment-methods">payment method</Link>. Contact Watches Pool to change your storage option.
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xl={12}>
                            <Card className="border-0 shadow-sm rounded-4 mb-4">
                                <Card.Body>
                                    <h5 className="fw-bold mb-3">Verification documents</h5>
                                    <Row className="g-3">
                                        {a.documents?.type === "cnic"
                                            ? [doc("CNIC front", a.documents.cnic_front_image), doc("CNIC back", a.documents.cnic_back_image)]
                                            : [doc(a.documents?.verification_document_type === "bank_statement" ? "Bank statement" : "Utility bill", a.documents?.verification_document)]}
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </>
                )}
            </Row>
        </PageLayout>
    );
}
